import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMunicipality } from '../hooks/useMunicipality';
import { useSidebar } from '../hooks/useSidebar';
import { LayoutDashboardIcon, ZapIcon, GaugeIcon, UsersIcon, BarChart3Icon, SettingsIcon, LogOutIcon, MapPinIcon, ChevronDownIcon, FactoryIcon, TrendingUpIcon, ShieldAlertIcon, CreditCardIcon, WalletIcon, BanknoteIcon, BuildingIcon, FileTextIcon, RefreshCwIcon, ActivityIcon, AlertTriangleIcon, WifiIcon, TrendingDownIcon, StoreIcon, BarChart2Icon, PercentIcon, MegaphoneIcon, MessageSquareIcon, LifeBuoyIcon } from 'lucide-react';
export function Sidebar() {
  const location = useLocation();
  const {
    collapsed,
    toggle
  } = useSidebar();
  const [metersOpen, setMetersOpen] = useState(location.pathname === '/meters' || location.pathname === '/lpu');
  const [vendingOpen, setVendingOpen] = useState(location.pathname === '/vending' || location.pathname === '/payment-integrations');
  const [revenueOpen, setRevenueOpen] = useState(location.pathname === '/prepaid-revenue' || location.pathname === '/lpu-revenue' || location.pathname === '/tariff-management' || location.pathname === '/billing-integrations');
  const [gridOpen, setGridOpen] = useState(location.pathname === '/substation-monitoring' || location.pathname === '/outage-detection' || location.pathname === '/network-diagnostics' || location.pathname === '/loss-analytics');
  const [vendorsOpen, setVendorsOpen] = useState(location.pathname.startsWith('/vendors') || location.pathname === '/vendor-map' || location.pathname === '/sales-performance' || location.pathname === '/commissions' || location.pathname === '/campaigns' || location.pathname === '/comm-channels');
  const isMetersSection = location.pathname === '/meters' || location.pathname === '/lpu' || location.pathname === '/map' || location.pathname === '/consumption-analytics' || location.pathname === '/fault-detection';
  const isVendingSection = location.pathname === '/vending' || location.pathname === '/payment-integrations';
  const isRevenueSection = location.pathname === '/prepaid-revenue' || location.pathname === '/lpu-revenue' || location.pathname === '/tariff-management' || location.pathname === '/billing-integrations';
  const isGridSection = location.pathname === '/substation-monitoring' || location.pathname === '/outage-detection' || location.pathname === '/network-diagnostics' || location.pathname === '/loss-analytics';
  const isVendorsSection = location.pathname.startsWith('/vendors') || location.pathname === '/vendor-map' || location.pathname === '/sales-performance' || location.pathname === '/commissions' || location.pathname === '/campaigns' || location.pathname === '/comm-channels';
  const navItems = [{
    path: '/dashboard',
    label: 'Dashboard',
    icon: LayoutDashboardIcon
  }];
  const renderNavLink = (item: {
    path: string;
    label: string;
    icon: any;
  }) => {
    const Icon = item.icon;
    const isActive = location.pathname === item.path;
    return <Link key={item.path} to={item.path} title={collapsed ? item.label : undefined} className={`w-full flex items-center gap-3 px-4 py-3 rounded-none transition-all duration-200 ${collapsed ? 'justify-center px-2' : ''} ${isActive ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-135">

        <Icon className={`w-5 h-5 shrink-0 ${isActive ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-136" />


        {!collapsed && item.label}
      </Link>;
  };
  const {
    selected: municipality
  } = useMunicipality();
  return <div className={`${collapsed ? 'w-16' : 'w-64'} min-h-screen flex flex-col text-white shadow-xl z-10 transition-all duration-300 ease-in-out`} style={{
    backgroundColor: municipality.accentColor
  }} data-id="element-137">

      <div className={`${collapsed ? 'p-3' : 'p-6'} border-b border-white/10 transition-all duration-300`} data-id="element-138">

        <div className={`flex items-center ${collapsed ? 'justify-center' : 'gap-3'} mb-2`} data-id="element-139">

          <div className="bg-white p-1.5 rounded-none shrink-0" data-id="element-140">
            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/s5dgpz2pomohbgjmvchnas/19620cb4-f500-4d30-868d-0c11080a1184/mavis_logo_letters.svg" alt="MAVIS Logo" className={`${collapsed ? 'h-6' : 'h-8'} w-auto object-contain transition-all duration-300`} data-id="element-141" />

          </div>
          {!collapsed && <h1 className="text-2xl font-bold tracking-tight" data-id="element-142">MAVIS</h1>}
        </div>
        {!collapsed && <p className="text-xs text-mavis-blue leading-tight opacity-80" data-id="element-143">
            Municipal Advanced Vending Infrastructure System
          </p>}
      </div>

      <nav className={`flex-1 py-6 ${collapsed ? 'px-1.5' : 'px-3'} space-y-1 overflow-y-auto overflow-x-hidden transition-all duration-300`} data-id="element-144">

        {navItems.map(renderNavLink)}

        {/* Vending Parent with Sub-items */}
        <div data-id="element-145">
          <button onClick={() => {
          if (collapsed) {
            toggle();
            setVendingOpen(true);
          } else {
            setVendingOpen(!vendingOpen);
          }
        }} title={collapsed ? 'Vending' : undefined} className={`w-full flex items-center ${collapsed ? 'justify-center px-2' : 'justify-between px-4'} py-3 rounded-none transition-all duration-200 ${isVendingSection ? 'bg-white/10 text-white font-semibold' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-146">

            <div className={`flex items-center ${collapsed ? '' : 'gap-3'}`} data-id="element-147">
              <ZapIcon className={`w-5 h-5 shrink-0 ${isVendingSection ? 'text-mavis-gold' : 'text-gray-400'}`} data-id="element-148" />


              {!collapsed && 'Vending'}
            </div>
            {!collapsed && <ChevronDownIcon className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${vendingOpen ? 'rotate-180' : ''}`} data-id="element-149" />}
          </button>

          {vendingOpen && !collapsed && <div className="mt-1 ml-4 pl-4 border-l border-white/10 space-y-1" data-id="element-150">
              <Link to="/vending" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/vending' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-151">

                <WalletIcon className={`w-4 h-4 ${location.pathname === '/vending' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-152" />

                Purchase Prepaid
              </Link>
              <Link to="/payment-integrations" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/payment-integrations' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-153">

                <CreditCardIcon className={`w-4 h-4 ${location.pathname === '/payment-integrations' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-154" />

                Payment Integrations
              </Link>
            </div>}
        </div>

        {/* Smart Meters Parent with Sub-items */}
        <div data-id="element-155">
          <button onClick={() => {
          if (collapsed) {
            toggle();
            setMetersOpen(true);
          } else {
            setMetersOpen(!metersOpen);
          }
        }} title={collapsed ? 'Smart Meters' : undefined} className={`w-full flex items-center ${collapsed ? 'justify-center px-2' : 'justify-between px-4'} py-3 rounded-none transition-all duration-200 ${isMetersSection ? 'bg-white/10 text-white font-semibold' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-156">

            <div className={`flex items-center ${collapsed ? '' : 'gap-3'}`} data-id="element-157">
              <GaugeIcon className={`w-5 h-5 shrink-0 ${isMetersSection ? 'text-mavis-gold' : 'text-gray-400'}`} data-id="element-158" />


              {!collapsed && 'Smart Meters'}
            </div>
            {!collapsed && <ChevronDownIcon className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${metersOpen ? 'rotate-180' : ''}`} data-id="element-159" />}
          </button>

          {metersOpen && !collapsed && <div className="mt-1 ml-4 pl-4 border-l border-white/10 space-y-1" data-id="element-160">
              <Link to="/meters" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/meters' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-161">

                <GaugeIcon className={`w-4 h-4 ${location.pathname === '/meters' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-162" />

                Residential
              </Link>
              <Link to="/lpu" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/lpu' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-163">

                <FactoryIcon className={`w-4 h-4 ${location.pathname === '/lpu' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-164" />

                Large Power Users
              </Link>
              <Link to="/map" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/map' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-165">

                <MapPinIcon className={`w-4 h-4 ${location.pathname === '/map' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-166" />

                Meter Map
              </Link>
              <Link to="/consumption-analytics" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/consumption-analytics' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-167">

                <TrendingUpIcon className={`w-4 h-4 ${location.pathname === '/consumption-analytics' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-168" />

                Consumption Analytics
                <span className="ml-auto text-[7px] font-bold uppercase tracking-wider px-1 py-0.5 bg-white text-mavis-gold leading-none shrink-0" data-id="element-169">
                  Alpha
                </span>
              </Link>
              <Link to="/fault-detection" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/fault-detection' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-170">

                <ShieldAlertIcon className={`w-4 h-4 ${location.pathname === '/fault-detection' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-171" />

                Fault Detection
                <span className="ml-auto text-[7px] font-bold uppercase tracking-wider px-1 py-0.5 bg-white text-mavis-gold leading-none shrink-0" data-id="element-172">
                  Alpha
                </span>
              </Link>
            </div>}
        </div>

        {/* Grid Balance Parent with Sub-items */}
        <div data-id="element-173">
          <button onClick={() => {
          if (collapsed) {
            toggle();
            setGridOpen(true);
          } else {
            setGridOpen(!gridOpen);
          }
        }} title={collapsed ? 'Grid Balance' : undefined} className={`w-full flex items-center ${collapsed ? 'justify-center px-2' : 'justify-between px-4'} py-3 rounded-none transition-all duration-200 ${isGridSection ? 'bg-white/10 text-white font-semibold' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-174">

            <div className={`flex items-center ${collapsed ? '' : 'gap-3'}`} data-id="element-175">
              <ActivityIcon className={`w-5 h-5 shrink-0 ${isGridSection ? 'text-mavis-gold' : 'text-gray-400'}`} data-id="element-176" />


              {!collapsed && <>
                  Grid Balance
                  <span className="ml-1 text-[8px] font-bold uppercase tracking-wider px-1.5 py-0.5 bg-white text-mavis-gold leading-none" data-id="element-177">
                    Alpha
                  </span>
                </>}
            </div>
            {!collapsed && <ChevronDownIcon className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${gridOpen ? 'rotate-180' : ''}`} data-id="element-178" />}
          </button>

          {gridOpen && !collapsed && <div className="mt-1 ml-4 pl-4 border-l border-white/10 space-y-1" data-id="element-179">
              <Link to="/substation-monitoring" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/substation-monitoring' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-180">

                <FactoryIcon className={`w-4 h-4 ${location.pathname === '/substation-monitoring' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-181" />

                Substation Monitoring
                <span className="ml-auto text-[7px] font-bold uppercase tracking-wider px-1 py-0.5 bg-white text-mavis-gold leading-none shrink-0" data-id="element-182">
                  Alpha
                </span>
              </Link>
              <Link to="/outage-detection" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/outage-detection' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-183">

                <AlertTriangleIcon className={`w-4 h-4 ${location.pathname === '/outage-detection' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-184" />

                Outage & Theft
                <span className="ml-auto text-[7px] font-bold uppercase tracking-wider px-1 py-0.5 bg-white text-mavis-gold leading-none shrink-0" data-id="element-185">
                  Alpha
                </span>
              </Link>
              <Link to="/network-diagnostics" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/network-diagnostics' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-186">

                <WifiIcon className={`w-4 h-4 ${location.pathname === '/network-diagnostics' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-187" />

                Network Diagnostics
                <span className="ml-auto text-[7px] font-bold uppercase tracking-wider px-1 py-0.5 bg-white text-mavis-gold leading-none shrink-0" data-id="element-188">
                  Alpha
                </span>
              </Link>
              <Link to="/loss-analytics" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/loss-analytics' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-189">

                <TrendingDownIcon className={`w-4 h-4 ${location.pathname === '/loss-analytics' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-190" />

                Loss Analytics
                <span className="ml-auto text-[7px] font-bold uppercase tracking-wider px-1 py-0.5 bg-white text-mavis-gold leading-none shrink-0" data-id="element-191">
                  Alpha
                </span>
              </Link>
            </div>}
        </div>

        {/* Vendors Parent with Sub-items */}
        <div data-id="element-192">
          <button onClick={() => {
          if (collapsed) {
            toggle();
            setVendorsOpen(true);
          } else {
            setVendorsOpen(!vendorsOpen);
          }
        }} title={collapsed ? 'Vendors' : undefined} className={`w-full flex items-center ${collapsed ? 'justify-center px-2' : 'justify-between px-4'} py-3 rounded-none transition-all duration-200 ${isVendorsSection ? 'bg-white/10 text-white font-semibold' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-193">

            <div className={`flex items-center ${collapsed ? '' : 'gap-3'}`} data-id="element-194">
              <UsersIcon className={`w-5 h-5 shrink-0 ${isVendorsSection ? 'text-mavis-gold' : 'text-gray-400'}`} data-id="element-195" />


              {!collapsed && 'Vendors'}
            </div>
            {!collapsed && <ChevronDownIcon className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${vendorsOpen ? 'rotate-180' : ''}`} data-id="element-196" />}
          </button>

          {vendorsOpen && !collapsed && <div className="mt-1 ml-4 pl-4 border-l border-white/10 space-y-1" data-id="element-197">
              <Link to="/vendors" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/vendors' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-198">

                <StoreIcon className={`w-4 h-4 ${location.pathname === '/vendors' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-199" />

                Vendor Management
              </Link>
              <Link to="/vendor-map" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/vendor-map' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-200">

                <MapPinIcon className={`w-4 h-4 ${location.pathname === '/vendor-map' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-201" />

                Vendor Map
              </Link>
              <Link to="/sales-performance" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/sales-performance' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-202">

                <BarChart2Icon className={`w-4 h-4 ${location.pathname === '/sales-performance' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-203" />

                Sales Performance
                <span className="ml-auto text-[7px] font-bold uppercase tracking-wider px-1 py-0.5 bg-white text-mavis-gold leading-none shrink-0" data-id="element-204">
                  Alpha
                </span>
              </Link>
              <Link to="/commissions" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/commissions' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-205">

                <PercentIcon className={`w-4 h-4 ${location.pathname === '/commissions' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-206" />

                Commissions
                <span className="ml-auto text-[7px] font-bold uppercase tracking-wider px-1 py-0.5 bg-white text-mavis-gold leading-none shrink-0" data-id="element-207">
                  Alpha
                </span>
              </Link>
              <Link to="/campaigns" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/campaigns' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-208">

                <MegaphoneIcon className={`w-4 h-4 ${location.pathname === '/campaigns' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-209" />

                Campaign Programs
                <span className="ml-auto text-[7px] font-bold uppercase tracking-wider px-1 py-0.5 bg-white text-mavis-gold leading-none shrink-0" data-id="element-210">
                  Alpha
                </span>
              </Link>
              <Link to="/comm-channels" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/comm-channels' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-211">

                <MessageSquareIcon className={`w-4 h-4 ${location.pathname === '/comm-channels' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-212" />

                Comm Channels
                <span className="ml-auto text-[7px] font-bold uppercase tracking-wider px-1 py-0.5 bg-white text-mavis-gold leading-none shrink-0" data-id="element-213">
                  Alpha
                </span>
              </Link>
            </div>}
        </div>

        {/* Revenue Parent with Sub-items */}
        <div data-id="element-214">
          <button onClick={() => {
          if (collapsed) {
            toggle();
            setRevenueOpen(true);
          } else {
            setRevenueOpen(!revenueOpen);
          }
        }} title={collapsed ? 'Revenue' : undefined} className={`w-full flex items-center ${collapsed ? 'justify-center px-2' : 'justify-between px-4'} py-3 rounded-none transition-all duration-200 ${isRevenueSection ? 'bg-white/10 text-white font-semibold' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-215">

            <div className={`flex items-center ${collapsed ? '' : 'gap-3'}`} data-id="element-216">
              <BarChart3Icon className={`w-5 h-5 shrink-0 ${isRevenueSection ? 'text-mavis-gold' : 'text-gray-400'}`} data-id="element-217" />


              {!collapsed && 'Revenue'}
            </div>
            {!collapsed && <ChevronDownIcon className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${revenueOpen ? 'rotate-180' : ''}`} data-id="element-218" />}
          </button>

          {revenueOpen && !collapsed && <div className="mt-1 ml-4 pl-4 border-l border-white/10 space-y-1" data-id="element-219">
              <Link to="/prepaid-revenue" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/prepaid-revenue' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-220">

                <BanknoteIcon className={`w-4 h-4 ${location.pathname === '/prepaid-revenue' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-221" />

                Prepaid Revenue
              </Link>
              <Link to="/lpu-revenue" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/lpu-revenue' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-222">

                <BuildingIcon className={`w-4 h-4 ${location.pathname === '/lpu-revenue' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-223" />

                LPU Management
              </Link>
              <Link to="/tariff-management" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/tariff-management' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-224">

                <FileTextIcon className={`w-4 h-4 ${location.pathname === '/tariff-management' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-225" />

                Tariff Management
              </Link>
              <Link to="/billing-integrations" className={`w-full flex items-center gap-3 px-3 py-2 rounded-none text-sm transition-all duration-200 ${location.pathname === '/billing-integrations' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10 hover:text-white'}`} data-id="element-226">

                <RefreshCwIcon className={`w-4 h-4 ${location.pathname === '/billing-integrations' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-227" />

                Billing Integrations
                <span className="ml-auto text-[7px] font-bold uppercase tracking-wider px-1 py-0.5 bg-white text-mavis-gold leading-none shrink-0" data-id="element-228">
                  Alpha
                </span>
              </Link>
            </div>}
        </div>
      </nav>

      <div className={`${collapsed ? 'p-2' : 'p-4'} border-t border-white/10 space-y-1 transition-all duration-300`} data-id="element-229">

        <Link to="/settings" title={collapsed ? 'System Settings' : undefined} className={`w-full flex items-center gap-3 ${collapsed ? 'justify-center px-2' : 'px-4'} py-2 rounded-none text-sm transition-colors ${location.pathname === '/settings' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10'}`} data-id="element-230">

          <SettingsIcon className={`w-4 h-4 shrink-0 ${location.pathname === '/settings' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-231" />


          {!collapsed && 'System Settings'}
        </Link>
        <Link to="/support" title={collapsed ? 'Support' : undefined} className={`w-full flex items-center gap-3 ${collapsed ? 'justify-center px-2' : 'px-4'} py-2 rounded-none text-sm transition-colors ${location.pathname === '/support' ? 'bg-mavis-gold text-mavis-teal font-semibold shadow-md' : 'text-gray-300 hover:bg-white/10'}`} data-id="element-232">

          <LifeBuoyIcon className={`w-4 h-4 shrink-0 ${location.pathname === '/support' ? 'text-mavis-teal' : 'text-gray-400'}`} data-id="element-233" />


          {!collapsed && 'Support'}
        </Link>
        <Link to="/login" title={collapsed ? 'Logout' : undefined} className={`w-full flex items-center gap-3 ${collapsed ? 'justify-center px-2' : 'px-4'} py-2 rounded-none text-sm text-gray-300 hover:bg-white/10 transition-colors`} data-id="element-234">

          <LogOutIcon className="w-4 h-4 shrink-0 text-gray-400" data-id="element-235" />
          {!collapsed && 'Logout'}
        </Link>
      </div>
    </div>;
}